/**
 * Conditionally loads popup.js only when overlay popups exist.
 * Keeps popup behavior off pages without `.popup` nodes.
 */
(function () {
  const loader = document.getElementById('PopupLoader');
  if (!loader) return;

  const popupSrc = loader.dataset.popup;
  if (!popupSrc) return;

  if (!document.querySelector('.popup')) return;

  const existing = document.querySelector(`script[src="${popupSrc}"]`);
  if (existing) return;

  const script = document.createElement('script');
  script.src = popupSrc;
  script.defer = true;
  script.addEventListener(
    'error',
    () => {
      console.error('[popup-loader]', new Error(`Failed to load ${popupSrc}`));
    },
    { once: true }
  );
  document.body.appendChild(script);
})();
